var render = function render(){var _vm=this,_c=_vm._self._c;return _c('error',{attrs:{"text":"A OCURRIDO UN ERROR AL CONSULTAR LOS DATOS"}})
}
var staticRenderFns = []

export { render, staticRenderFns }